import { useMemo } from "react";

import { Tab } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";

import { CourseGradebook } from "./course.gradebook";
import { TrainGradebook } from "./train.gradebook";

export const ClassroomGradebookTab = ({
  name,
  className,
  classroom,
  users,
  selectedUser,
  activityStatus,
  product,
  readOnly,
}) => {
  const gradebookTab = useMemo(() => {
    return {
      [Product.TS]: (
        <TrainGradebook
          users={users}
          classroom={classroom}
          readOnly={readOnly}
        />
      ),
      [Product.PROG]: (
        <CourseGradebook
          users={users}
          classroom={classroom}
          selectedUser={selectedUser}
          activityStatus={activityStatus}
          readOnly={readOnly}
        />
      ),
    };
  }, [classroom, users, selectedUser, activityStatus, product, readOnly]);

  return (
    <Tab name={name} className={className}>
      {gradebookTab[product]}
    </Tab>
  );
};
